import script from "./base-company-dialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./base-company-dialog.vue?vue&type=script&lang=tsx&setup=true"

import "./base-company-dialog.vue?vue&type=style&index=0&id=7ec521a0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec521a0"]])

export default __exports__